module.exports = __webpack_public_path__ + "3f16e137/img/product-icon-grey.b248963c.svg";